(() => {
  'use strict';

  const POLICY_ROOT = '.shopify-policy__container .shopify-policy__body .rte';
  const CLASS_NAMES = [
    'sky-policy-kicker',
    'sky-policy-intro',
    'sky-policy-major',
    'sky-policy-section',
    'sky-policy-subsection',
    'sky-policy-notice',
    'sky-policy-stand',
  ];

  const normalize = (value) =>
    value.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();

  const fold = (value) =>
    normalize(value)
      .toLocaleLowerCase('en-GB')
      .replace(/ı/g, 'i')
      .normalize('NFKD')
      .replace(/\p{M}/gu, '');

  const SECTION_TITLES = new Set(
    [
      'Zahlungsmöglichkeiten',
      'Zahlungsabwicklung',
      'Liefergebiet',
      'Versandkosten',
      'Liefergebiet und Versandkosten',
      'Lieferzeiten',
      'Hinweis zu individuell eingerichteten Systemen',
      'Individuell eingerichtete Kassensysteme',
      'Selbstabholung',
      'Transportschäden',
      'Fragen zu Zahlung oder Lieferung',
      'Kein gesetzliches Widerrufsrecht',
      'Stornierung vor Ausführung oder Versand',
      'Rückgabe mangelfreier Ware',
      'Individuell eingerichtete und konfigurierte Systeme',
      'Mängelrechte',
      'Kontakt',
      'Registerangaben',
      'Hinweis zum Angebot',
      'Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)',
      'Payment methods',
      'Payment processing',
      'Delivery area',
      'Shipping costs',
      'Delivery area and shipping costs',
      'Delivery times',
      'Note on individually configured systems',
      'Individually configured POS systems',
      'Local pickup',
      'Transport damage',
      'Questions about payment or delivery',
      'No statutory right of withdrawal',
      'Cancellation before performance or dispatch',
      'Return of non-defective goods',
      'Individually installed and configured systems',
      'Defect rights',
      'Warranty rights',
      'Contact',
      'Register information',
      'Registry details',
      'Offer notice',
      'Note on the offer',
      'Information pursuant to Section 5 of the German Digital Services Act (DDG)',
      'Legal notice',
      'Imprint',
      'Ödeme seçenekleri',
      'Ödeme işlemleri',
      'Teslimat bölgesi',
      'Kargo ücretleri',
      'Teslimat bölgesi ve kargo ücretleri',
      'Teslimat süreleri',
      'Özel yapılandırılmış sistemler hakkında bilgi',
      'Özel yapılandırılmış kasa sistemleri',
      'Mağazadan teslim',
      'Nakliye hasarları',
      'Ödeme veya teslimatla ilgili sorular',
      'Yasal cayma hakkı yoktur',
      'İfa veya sevkiyat öncesi iptal',
      'Ayıpsız malların iadesi',
      'Bireysel olarak kurulan ve yapılandırılan sistemler',
      'Ayıplara karşı haklar',
      'İletişim',
      'Ticaret sicili bilgileri',
      'Teklife ilişkin not',
      'DDG § 5 uyarınca bilgiler',
      'Künye',
    ].map(fold),
  );

  const classify = (text) => {
    if (/^SKYLINE\s+PAYMENT(?:®)?\s*[·•—–-]/iu.test(text)) return 'kicker';
    if (/^(?:IMPRESSUM|LEGAL\s+NOTICE|IMPRINT|KÜNYE)$/iu.test(text)) return 'kicker';
    if (/^[IVXLCDM]+\.\s+\S/iu.test(text)) return 'major';
    if (/^§\s*\d+[a-z]?\b/iu.test(text)) return 'section';
    if (SECTION_TITLES.has(fold(text))) return 'section';
    if (/^(?:Anbieter,\s+Kontakt\s+und\s+Vertragssprache|Provider,\s+contact\s+and\s+contract\s+language|Sağlayıcı,\s+iletişim\s+ve\s+sözleşme\s+dili)$/iu.test(text)) return 'subsection';
    if (/^(?:Wichtiger\s+B2B-Hinweis|Important\s+B2B\s+notice|Önemli\s+B2B\s+bilgisi)\s*:/iu.test(text)) return 'notice';
    if (/^(?:Unser\s+Angebot\s+richtet\s+sich\s+ausschließlich\s+an\s+Unternehmer|Our\s+offer\s+is\s+intended\s+exclusively\s+for\s+businesses|Teklifimiz\s+yalnızca\s+ticari\s+müşterilere\s+yöneliktir)\b/iu.test(text)) return 'notice';
    if (/^(?:Stand|Last\s+updated|Son\s+güncelleme)\s*:/iu.test(text)) return 'stand';
    return null;
  };

  const enhancePolicy = () => {
    const root = document.querySelector(POLICY_ROOT);
    if (!root) return;

    const paragraphs = Array.from(root.querySelectorAll('p'));
    let introCandidate = false;

    paragraphs.forEach((paragraph) => {
      const text = normalize(paragraph.textContent || '');
      if (!text) return;

      const previousType = paragraph.dataset.skyPolicyType;
      paragraph.classList.remove(...CLASS_NAMES);
      paragraph.removeAttribute('data-sky-policy-type');
      if (previousType === 'major' || previousType === 'section' || previousType === 'subsection') {
        paragraph.removeAttribute('role');
        paragraph.removeAttribute('aria-level');
      }

      const type = classify(text);

      if (type) {
        paragraph.classList.add(`sky-policy-${type}`);
        paragraph.dataset.skyPolicyType = type;

        if (type === 'major' || type === 'section' || type === 'subsection') {
          paragraph.setAttribute('role', 'heading');
          paragraph.setAttribute('aria-level', type === 'major' ? '2' : '3');
        }

        introCandidate = type === 'kicker';
        return;
      }

      if (introCandidate) {
        paragraph.classList.add('sky-policy-intro');
        paragraph.dataset.skyPolicyType = 'intro';
        introCandidate = false;
      }
    });

    root.dataset.skyPolicyEnhanced = 'true';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancePolicy, { once: true });
  } else {
    enhancePolicy();
  }

  document.addEventListener('shopify:section:load', enhancePolicy);
})();
